export { type DocumentInput, Document } from "@langchain/core/documents";
